const Validations = {
  part_properties: {
    part_category_id: [
      { required: true, message: 'Category cannot be empty!', trigger: 'change', type: 'integer' }
    ],
    name: [
      { required: true, message: 'Name cannot be empty!', trigger: 'change' }
    ],
    specification: [
      { required: true, message: 'Specification is required!', trigger: 'change' }
    ],
    chinese_name: [
      { required: true, message: 'Chinese Name cannot be empty!', trigger: 'change' }
    ],
    unit: [
      { required: true, message: 'Unit cannot be empty!', trigger: 'change' }
    ]
  },
  purchase_properties: {
    mpq: [
      { required: true, type: 'number', message: 'MOQ cannot be empty!', trigger: 'change' }
    ],
    moq: [
      { required: true, type: 'number', message: 'MPQ Quantity cannot be empty!', trigger: 'change' }
    ],
    base_increase: [
      { required: true, type: 'number', message: 'Base Increase cannot be empty!', trigger: 'change' }
    ],
    purchase_days: [
      { required: true, type: 'number', message: 'Purchase Days cannot be empty!', trigger: 'change' }
    ],
    stander_cost: [
      { required: true, type: 'number', message: 'Stander Cost cannot be empty!', trigger: 'change' }
    ],
    major_supplier: [
      { required: true, message: 'Major Supplier cannot be empty!', trigger: 'change' }
    ],
    unit_id: [
      { required: true, message: 'Unit cannot be empty!', trigger: 'change' }
    ],
    tax_rate: [
      { required: true, type: 'number', message: 'Description cannot be empty!', trigger: 'change' }
    ]
  },
  quanlity_properties: {}
}

export default Validations
